"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "36", height: "37", viewBox: "0 0 36 37", className: "Icon element-link", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "defs",
            null,
            _react2.default.createElement("path", { id: "b-element-link", d: "M1 1h34v34H1z" }),
            _react2.default.createElement(
                "filter",
                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "a-element-link" },
                _react2.default.createElement("feOffset", { dy: "1", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
                _react2.default.createElement("feGaussianBlur", { stdDeviation: ".5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0.431372549 0 0 0 0 0.431372549 0 0 0 0 0.443137255 0 0 0 0.329313859 0", "in": "shadowBlurOuter1" })
            )
        ),
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement(
                "g",
                null,
                _react2.default.createElement("use", { fill: "#000", filter: "url(#a-element-link)", xlinkHref: "#b-element-link" }),
                _react2.default.createElement("use", { fill: "#FFF", xlinkHref: "#b-element-link" })
            ),
            _react2.default.createElement("path", { d: "M36 0v36H0V0h36zM1 1v34h34V1H1z", fill: "#A5A5A5" }),
            _react2.default.createElement("path", { d: "M17.156 18.833c-1.146-1.05-1.13-2.599 0-3.637l3.565-3.601c1.241-1.428 3.17-1.744 4.339-.56 1.135 1.15.748 2.962-.688 4.208l-2.211 2.136a.65.65 0 1 0 .903.934l2.186-2.112c1.916-1.662 2.482-4.31.735-6.08-1.764-1.785-4.551-1.328-6.217.59l-3.513 3.55c-1.664 1.527-1.69 3.96.023 5.53a.65.65 0 1 0 .878-.958z", fill: "#333" }),
            _react2.default.createElement("path", { d: "M18.855 17.13c1.147 1.05 1.13 2.599 0 3.638l-3.544 3.61c-1.24 1.425-3.168 1.741-4.337.557-1.135-1.15-.749-2.96.688-4.207l2.21-2.136a.65.65 0 1 0-.903-.934l-2.185 2.112c-1.917 1.662-2.482 4.31-.735 6.078 1.763 1.786 4.55 1.329 6.216-.59l3.493-3.556c1.663-1.527 1.69-3.96-.025-5.531a.65.65 0 0 0-.878.958z", fill: "#333" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/element-link.js
// module id = 1798
// module chunks = 0